// extracted by mini-css-extract-plugin
export default {"cls1":"fDUmMy8gHKOLhf7WvDrM","cls2":"sSDJzoxTWd6vfXy3bsaw fDUmMy8gHKOLhf7WvDrM"};